import { render, staticRenderFns } from "./MultimodalSop.vue?vue&type=template&id=8e9dffda&scoped=true&"
import script from "./MultimodalSop.vue?vue&type=script&lang=js&"
export * from "./MultimodalSop.vue?vue&type=script&lang=js&"
import style0 from "./MultimodalSop.vue?vue&type=style&index=0&id=8e9dffda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9dffda",
  null
  
)

export default component.exports